var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-list-item', {
    attrs: {
      "to": "/quest/".concat(_vm.id)
    }
  }, [_vm.character ? _c('v-list-item-avatar', {
    staticClass: "mx-auto mr-2 mr-md-4",
    attrs: {
      "size": _vm.$size()
    }
  }, [_c('CharaIcon', {
    attrs: {
      "id": _vm.quest.section,
      "size": _vm.$size()
    }
  })], 1) : _c('v-list-item-avatar', {
    staticClass: "mx-auto mr-2 mr-md-4",
    attrs: {
      "color": "primary",
      "size": _vm.$size(32)
    }
  }, [_c('span', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.quest.section))])]), _c('v-list-item-content', {
    staticClass: "mr-auto ml-0"
  }, [_c('v-list-item-title', [_vm.quest.name ? _c('span', [_vm._v(_vm._s(_vm.quest.name))]) : _c('span', [_vm._v(_vm._s(_vm.$t('Quest')) + " " + _vm._s(_vm.id))]), _vm.quest.stamina && _vm.quest.stamina != -1 ? _c('div', {
    staticClass: "float-right"
  }, [_c('v-avatar', {
    attrs: {
      "size": _vm.$size() / 2.5,
      "tile": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.commonuiatlas.format('StaminaIcon') + '.png',
      "contain": ""
    }
  })], 1), _c('small', [_vm._v(" " + _vm._s(_vm.quest.stamina))])], 1) : _vm._e(), _vm.quest.exId2 && _vm.quest.exId2 != -1 ? _c('div', {
    staticClass: "float-right"
  }, [_c('v-avatar', {
    attrs: {
      "size": _vm.$size() / 2.5
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.itemicon.format(_vm.quest.exId2) + '.jpg'
    }
  })], 1), _vm.quest.ex2Amount != 1 ? _c('small', [_vm._v(" " + _vm._s(_vm.quest.ex2Amount))]) : _vm._e()], 1) : _vm._e()]), _c('v-list-item-subtitle', {
    staticClass: "d-flex align-center pt-2"
  }, [_c('span', {
    staticClass: "hidden-xs-only pr-2"
  }, [_vm._v(_vm._s(_vm.$t('Enemies')))]), _c('div', {
    staticClass: "d-flex flex-row",
    attrs: {
      "icon": _vm.$size(32)
    }
  }, _vm._l(_vm.quest.enemyResourceIDs, function (enemyResourceID) {
    return _c('div', {
      key: "questlibrary-quest-enemy-".concat(enemyResourceID),
      staticClass: "mr-2"
    }, [_c('v-avatar', {
      attrs: {
        "size": _vm.$size(32)
      }
    }, [_c('v-img', {
      attrs: {
        "src": _vm.$asset.ordericon.format(enemyResourceID) + '.jpg'
      }
    })], 1)], 1);
  }), 0)]), _vm.quest.items.length ? _c('v-list-item-subtitle', {
    staticClass: "d-flex align-center pt-2"
  }, [_c('span', {
    staticClass: "hidden-xs-only pr-2"
  }, [_vm._v(_vm._s(_vm.$t('Drops')))]), _c('div', {
    staticClass: "d-flex flex-row flex-wrap",
    attrs: {
      "icon": _vm.$size(32)
    }
  }, _vm._l(_vm.itemOrder, function (x, i) {
    return _c('div', {
      key: "questlibrary-quest-item-".concat(i),
      staticClass: "mr-2 d-flex"
    }, [_c('v-avatar', {
      staticClass: "mr-1",
      attrs: {
        "size": _vm.$size(32)
      }
    }, [_c('v-img', {
      attrs: {
        "src": _vm.$asset.itemicon.format(_vm.items[i]) + '.jpg'
      }
    })], 1), _c('div', {
      staticClass: "d-flex justify-center flex-column"
    }, [_c('div', {
      staticClass: "caption",
      staticStyle: {
        "line-height": "1rem"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.amounts[i])
      }
    })])], 1);
  }), 0)]) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }